import { render, staticRenderFns } from "./CreateRecipe.vue?vue&type=template&id=314517c1"
import script from "./CreateRecipe.vue?vue&type=script&lang=js"
export * from "./CreateRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports